import * as React from "react";

const Select = React.forwardRef(
  (
    { className, label, options, isRequired, hasError, placeholder, ...props },
    ref
  ) => {
    return (
      <div>
        <label className="block text-gray-600 mb-2 font-semibold">
          {label} {isRequired && <span className="text-red-600">*</span>}
        </label>

        <select
          className={`flex h-10 w-full rounded-lg border text-gray-600 border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-50 ${className} ${
            hasError ? "border-red-500 focus:ring-red-500" : "border-gray-300"
          }`}
          ref={ref}
          {...props}
        >
          <option disabled value="">
            {placeholder || "Pick one"}
          </option>

          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
);
Select.displayName = "Select";

export { Select };
